import { APP_INITIALIZER } from '@angular/core';
import { ConfigService } from '../../services/config/config.service';
import { appVersion } from '../../../version';
import { take } from 'rxjs/operators';
import * as Sentry from '@sentry/angular-ivy';
import { Integrations } from '@sentry/tracing';
import { environment } from '../../../environments/environment.prod';

export const loadSentry = () =>
    new Promise(resolve => {
        ConfigService.configLoaded$
            .pipe(take(1))
            .subscribe(() => {
                const env = ConfigService.get('env');
                const enableSentry = environment.production && ConfigService.get('isProduction');

                if (enableSentry) {
                    Sentry.init({
                        environment: env,
                        release: appVersion,
                        dsn: 'https://a03f5394a5714a9eb17e85be310cea3e@o233518.ingest.sentry.io/5226760',
                        ignoreErrors: [
                            'Non-Error exception captured'
                        ],
                        integrations: [
                            new Integrations.BrowserTracing({
                                routingInstrumentation: Sentry.routingInstrumentation,
                            }),
                            new Sentry.Replay()
                        ],
                        tracesSampleRate: 1.0,
                        replaysSessionSampleRate: 0,
                        replaysOnErrorSampleRate: 1.0
                    });
                }
                resolve(true);
            });
    });


export const init = () =>
    ({
        provide: APP_INITIALIZER,
        useValue: loadSentry,
        multi: true
    });

export const SentryInitializer = {
    init
};
